<template>
  <div
    :class="[
      'hab-datepicker',
      {
        [`${className}`]: className,
        [`theme-${theme}`]: theme,
      },
    ]"
  >
    <div class="datepicker">
      <label v-if="label">{{ label }}<span v-if="required"></span></label>
      <div>
        <date-picker
          :type="type"
          :clearable="clearable"
          :lang="lang"
          :format="format"
          :placeholder="placeholder"
          :disabled="disabled"
          :default-value="defaultValue"
          :disabled-date="handleDisableDate"
          :value="value"
          @change="onChange"
        />
      </div>
    </div>
    <span v-if="error" class="alert-input-error">{{ error }}</span>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  components: {
    DatePicker,
  },
  props: {
    clearable: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "date",
    },
    format: {
      type: String,
      default: "YYYY-MM-DD",
    },
    lang: {
      type: String,
      default: "vn",
    },
    disableDate: {
      type: null,
    },
    placeholder: {
      type: String,
      default: "",
    },
    className: {
      type: String,
      default: "",
    },
    defaultValue: {
      type: null,
      default() {
        return new Date();
      },
    },
    value: {
      type: null,
      default: null,
    },
    label: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: "",
    },
    onDisableDate: {
      type: null,
      default() {
        return false;
      },
    },
    theme: {
      type: [String, Number],
      default: null,
    },
  },
  emits: ["onChange"],
  methods: {
    handleDisableDate(date) {
      const d = new Date();
      d.setDate(d.getDate() - 1);

      return d > date;
    },
    onChange(values) {
      return this.$emit("onChange", values);
    },
  },
};
</script>

<style lang="scss">
.hab-datepicker {
  &.theme {
    &-1 {
      .mx-input {
        border-color: transparent;
        box-shadow: none;
        padding: 6px 40px !important;
        padding-right: 10px !important;
      }
      .mx-icon-calendar {
        right: auto;
        left: 8px;
        color: #007aff;
        font-size: 22px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.hab-datepicker {
  position: relative;
  .datepicker {
    .mx-datepicker {
      width: 100%;
    }
    .name {
      font-size: 14px;
      font-weight: 500;
      line-height: 120%;
      margin: 0;
      margin-bottom: 10px;
      span {
        margin-left: 4px;
        &::before {
          content: "*";
          color: #f00;
        }
      }
    }
  }
}
</style>
